import ApiService from '../apiservice'

export default class GraficoAtividadeService extends ApiService {
  constructor() {
    super('/atividadeGraficos');
  }

  graficoTotal(empresa, dataInicial, dataFinal) {
    return this.get(`/total?empresa=${empresa}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
  }

  graficoDataLimite(empresa, dataInicial, dataFinal) {
    return this.get(`/dataLimite?empresa=${empresa}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`)
  }

  graficoDataConcluido(empresa, dataInicial, dataFinal) {
    return this.get(`/concluido?empresa=${empresa}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`)
  }

  graficoAtividadesStatus(empresa, dataInicial, dataFinal) {
    return this.get(`/status?empresa=${empresa}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`)
  }

  graficoAtividadesSituacao(empresa, dataInicial, dataFinal) {
    return this.get(`/situacao?empresa=${empresa}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
  }

  graficoAtividadeStatusUsuarioPainel(usuario) {
    return this.get(`/graficoStatusUsuarioPainel?usuario=${usuario}`);
  }

  graficoAtividadeGrupo(empresa, dataInicial, dataFinal) {
    return this.get(`/graficoAtividadeGrupo?empresa=${empresa}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
  }

  graficoAtividadeFase(empresa, dataInicial, dataFinal) {
    return this.get(`/graficoAtividadeFase?empresa=${empresa}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
  }

  graficoAtividadeFaseProcesso(processo) {
    return this.get(`/graficoFasePorProcesso/${processo}`);
  }

  graficoAtividadeStatusProcesso(processo) {
    return this.get(`/graficoStatusPorProcesso/${processo}`);
  }

  graficoPontuacaoTotal(empresa,dataInicial,dataFinal) {
    return this.get(`/grafico-pontuacao-total?empresa=${empresa}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
  }

  pontuacaoUsuariosDados(empresa,dataInicial,dataFinal) {
    return this.get(`/pontos-usuarios-projecao-dados?empresa=${empresa}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
  }

  consultarAtividadesPorUsuario(usuario,dataInicial,dataFinal,tipoConsulta) {
    return this.get(`/atividades-detalhe-usuario?usuario=${usuario}&dataInicial=${dataInicial}&dataFinal=${dataFinal}&tipoConsulta=${tipoConsulta}`);
  }

  consultarAtividadesRanking(empresa,dataInicial,dataFinal) {
    return this.get(`/ranking-atividades?empresa=${empresa}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
  }
}